import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  Error as ErrorIcon,
  PageHeading,
  SecondaryButton
} from '@nextgen/frontend-components-atoms';
import { useHistory } from 'react-router-dom';
import * as S from './Error.styles';

const Error = ({
  linkText,
  link,
  headingText,
  buttonText,
  errorMessage,
  errorMessage2
}) => {
  const history = useHistory();
  const redirectHomepage = () => {
    history.replace('/content/homepage');
  };
  return (
    <S.Error>
      <S.Icon>
        <ErrorIcon />
      </S.Icon>
      <PageHeading title={headingText} className="errorClass" />
      <S.Message>
        {errorMessage}
        {link && linkText && (
          <S.Link>
            <Link className="link" to={link}>
              {linkText}
            </Link>
          </S.Link>
        )}
        {errorMessage2}
      </S.Message>
      <S.Button>
        <SecondaryButton onClick={redirectHomepage}>
          {buttonText}
        </SecondaryButton>
      </S.Button>
    </S.Error>
  );
};

Error.propTypes = {
  buttonText: PropTypes.string,
  errorMessage: PropTypes.string,
  errorMessage2: PropTypes.string,
  headingText: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string
};

export default Error;
